import { Card, CardContent, Typography, CardMedia, Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { NewsItem } from "../newsTypes"
import { useExternalLinks } from "../../../shared/hooks/useAppLinks"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faNewspaper } from "@fortawesome/pro-solid-svg-icons"
import { tailwindPalette } from "../../theme/tailwindPalette"

type NewsCardProps = Readonly<{
    news: NewsItem
}>

export const NewsCard = ({ news }: NewsCardProps) => {
    const useStyles = makeStyles()(() => ({
        newsGrid: {
            justifyContent: "center",
            border: "none",
            alignSelf: "flex-start",
            "&:hover": {
                transform: "scale(1.02)",
                transition: "all .3s ease-in-out",
            },
        },
        card: {
            cursor: "pointer",
            backgroundColor: "transparent",
            width: "33,33%", // set according to gap %

            // paddingBottom: "0",
            // marginBottom: '0',
            // [theme.breakpoints.down(1000)]: {
            //     width: "49.5%", // set according to gap %
            // },

            // [theme.breakpoints.down("sm")]: {
            //     width: "100%",
            // },
        },
        cardMedia: {
            borderRadius: ".25rem",
            aspectRatio: "16/9",
        },
        cardContent: {
            padding: "0",
            paddingBottom: "0",
            paddingTop: "0.75rem",
        },
        iconContainer: {
            backgroundColor: tailwindPalette.gray[300],
            aspectRatio: "16/9",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: ".25rem",
        },
        icon: {
            color: "white",
            fontSize: "3rem",
        },
    }))

    const { classes, cx } = useStyles()
    const handleExternalLink = useExternalLinks()

    return (
        <Card
            key={news.subject}
            variant="outlined"
            className={cx(classes.newsGrid, classes.card)}
            onClick={() => handleExternalLink(news.permaLink)}
        >
            {news.imageUrl ? (
                <CardMedia src={news.imageUrl} classes={{ root: classes.cardMedia }} component="img" />
            ) : (
                <Box className={classes.iconContainer}>
                    <FontAwesomeIcon icon={faNewspaper} className={classes.icon} />
                </Box>
            )}

            <CardContent className={classes.cardContent}>
                <Typography variant="h6" fontWeight={400} sx={{ lineHeight: "1.5rem" }}>
                    {news.subject}
                </Typography>
            </CardContent>
        </Card>
    )
}
